import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";
import { usePrintQueue, QueueItem } from "../print-queue-context";
import { useState, useEffect, useRef } from "react";
// import { useToast } from "@/hooks/use-toast";

const printKeyTagsPDF = (items: QueueItem[]): (() => void) => {
  // Create pages with max 4 items each
  const itemsPerPage = 4;
  const pages = [];

  for (let i = 0; i < items.length; i += itemsPerPage) {
    pages.push(items.slice(i, i + itemsPerPage));
  }

  // Create a temporary div with the print content
  const printDiv = document.createElement("div");
  printDiv.className = "key-tags-print-content";
  printDiv.style.position = "fixed";
  printDiv.style.top = "-9999px";
  printDiv.style.left = "-9999px";

  const printContent = `
      <style>
        .truncate {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
      
 .key-tag-card {
          width: 2.5cm !important;
          min-width: 2.5cm !important;
          max-width: 2.5cm !important;
          height: 4cm !important;
          min-height: 4cm !important;
          box-sizing: border-box;
        } 
        
        @media print {
          body > *:not(.key-tags-print-content) { 
            display: none !important; 
          }
          
          .key-tags-print-content { 
            position: static !important;
            top: auto !important;
            left: auto !important;
            display: block !important;
            visibility: visible !important;
          }
          
          .page-break {
            page-break-before: always;
          }
          
          .page-break:first-child {
            page-break-before: auto;
          }
        }
      </style>
      
      <div class="font-sans bg-white p-5 max-w-4xl mx-auto">
        ${pages
      .map(
        (pageItems, pageIndex) => `
          <div class="${pageIndex > 0 ? "page-break" : ""} mb-8">
            <div class="text-center mb-8 border-b-2 border-gray-800 pb-4">
              <h1 class="text-2xl font-bold text-gray-800 mb-2">Vehicle Key Tags</h1>
              <p class="text-gray-600 text-sm">
                Printed on ${new Date().toLocaleDateString()} - Page ${pageIndex + 1
          } of ${pages.length} (${pageItems.length} tag(s))
              </p>
            </div>
            
            <div class=" flex flex-row gap-5  mb-5">
              ${pageItems
            .map(
              (item) => `
              <div class="flex flex-col items-center justify-center gap-5">
                <div class="key-tag-card border-2 border-gray-800 rounded-lg p-1 flex flex-col justify-center gap-2 bg-gray-50 break-inside-avoid overflow-hidden">
                 
                  
                  <div class="keysHolder w-full">
                  
                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.year || "N/A"
                }</span>
                    </div>

                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.model ? item.vehicle.model.split(/[\s\/]/)[0] : "N/A"
                }</span>
                    </div>

                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.modelCode ? (item.vehicle.modelCode.includes(' ') ? item.vehicle.modelCode.split(' ')[0] : item.vehicle.modelCode.substring(0, 10)) : "N/A"
                }</span>
                    </div>
                  
                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.color || "N/A"
                }</span>
                    </div>

                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.vin ? item.vehicle.vin.slice(-8) : "N/A"
                }</span>
                    </div>
                    
                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.stockNumber || "N/A"
                }</span>
                    </div>
                  </div>
                </div>
                <div class="key-tag-card border-2 border-gray-800 rounded-lg p-1 flex flex-col justify-center gap-2 bg-gray-50 break-inside-avoid overflow-hidden">
                 
                  
                  <div class="keysHolder w-full">
                  
                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.year || "N/A"
                }</span>
                    </div>

                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.model ? item.vehicle.model.split(/[\s\/]/)[0] : "N/A"
                }</span>
                    </div>

                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.modelCode ? (item.vehicle.modelCode.includes(' ') ? item.vehicle.modelCode.split(' ')[0] : item.vehicle.modelCode.substring(0, 10)) : "N/A"
                }</span>
                    </div>
                  
                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.color || "N/A"
                }</span>
                    </div>

                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.vin ? item.vehicle.vin.slice(-8) : "N/A"
                }</span>
                    </div>
                    
                    <div class="flex justify-center items-center py-1 border-b border-dotted border-gray-300 w-full">
                      <span class="text-[10px] font-medium truncate w-full text-center block">${item.vehicle.stockNumber || "N/A"
                }</span>
                    </div>
                  </div>
                </div>
              </div>
              `
            )
            .join("")}
            </div>
            
            <div class="text-center mt-8 pt-4 border-t border-gray-300 text-gray-600 text-xs">
              Generated by Performance Auto Group
            </div>
          </div>
        `
      )
      .join("")}
      </div>
    `;

  printDiv.innerHTML = printContent;
  document.body.appendChild(printDiv);

  // Trigger print dialog
  window.print();

  // Clean up after printing and return cleanup function
  const cleanupTimeout = setTimeout(() => {
    if (document.body.contains(printDiv)) {
      document.body.removeChild(printDiv);
    }
  }, 1000);

  // Return cleanup function
  return () => {
    clearTimeout(cleanupTimeout);
    if (document.body.contains(printDiv)) {
      document.body.removeChild(printDiv);
    }
  };
};

export const PrintQueueBadge = () => {
  // const { toast } = useToast();
  const printQueue = usePrintQueue();
  const prevValueRef = useRef(printQueue.value);
  const printCleanupRef = useRef<(() => void) | null>(null);
  const [snackbar, setSnackbar] = useState({
    show: false,
    message: "",
    type: "",
  });

  const handlePrintKeyTags = () => {
    // Get all items from queue (no limit here)
    const itemsToPrint = printQueue.queue;

    if (itemsToPrint.length === 0) {
      console.log("No items to print");
      return;
    }

    // Clean up any previous print cleanup
    if (printCleanupRef.current) {
      printCleanupRef.current();
    }

    // Create and print the PDF content, store cleanup function
    printCleanupRef.current = printKeyTagsPDF(itemsToPrint);

    // Optionally clear the queue after printing
    // printQueue.clearQueue();

    // toast({ title: "Success", description: "Printed successfully." });
  };

  // Listen for queue changes and show snackbar
  useEffect(() => {
    const prevValue = prevValueRef.current;
    const currentValue = printQueue.value;

    if (prevValue !== currentValue) {
      if (currentValue > prevValue) {
        setSnackbar({
          show: true,
          message: "Added to print queue",
          type: "add",
        });
      } else if (currentValue < prevValue) {
        setSnackbar({
          show: true,
          message: "Removed from print queue",
          type: "remove",
        });
      }

      // Update the ref for next comparison
      prevValueRef.current = currentValue;

      // Auto-hide snackbar after animation
      const timeout = setTimeout(() => {
        setSnackbar((prev) => ({ ...prev, show: false }));
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [printQueue.value]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (printCleanupRef.current) {
        printCleanupRef.current();
      }
    };
  }, []);

  return printQueue.value > 0 ? (
    <div className="fixed bottom-20 right-8 z-10">
      <div className="relative">
        {/* Snackbar */}
        <div
          className={`
            absolute bottom-3 right-0 bg-slate-100 text-gray-800 px-4 py-2 rounded-lg shadow-lg 
            whitespace-nowrap text-sm font-medium transition-all duration-500 ease-out
            ${snackbar.show
              ? "translate-x-[-50px] opacity-100"
              : "translate-x-0 opacity-0"
            }
          `}
          style={{
            transform: snackbar.show ? "translateX(-50px)" : "translateX(0px)",
            zIndex: -1,
          }}
        >
          {snackbar.message}
          {/* Arrow pointing to badge */}
          <div className="absolute top-1/2 right-[-6px] transform -translate-y-1/2 w-0 h-0 border-l-[6px] border-l-slate-100 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
        </div>

        {/* Print Button */}
        <Button
          className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center shadow-lg"
          onClick={handlePrintKeyTags}
        >
          <Printer
            className="text-white"
            style={{ width: "1.4rem", height: "1.4rem" }}
          />
        </Button>

        {/* Badge */}
        <div className="absolute -top-1 -right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md border border-gray-200">
          <span className="text-xs font-semibold text-gray-800">
            {printQueue.value}
          </span>
        </div>
      </div>
    </div>
  ) : null;
};
